import React from 'react';

export default function SignInPromptModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.35)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 24,
        maxWidth: 420,
        width: '90%',
        boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
        padding: '2.5rem 2rem 2rem 2rem',
        position: 'relative',
        textAlign: 'center',
      }}>
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: 18,
            right: 18,
            background: 'none',
            border: 'none',
            fontSize: 28,
            color: '#888',
            cursor: 'pointer',
            zIndex: 10,
          }}
        >
          ×
        </button>
        <div style={{ fontSize: 28, fontWeight: 600, marginBottom: 18, color: '#1a2b13', lineHeight: 1.2 }}>
          To keep exploring courses,<br />log in or sign up for free
        </div>
        <div style={{
          fontSize: 16,
          color: '#1D665D',
          background: '#e4f8ec',
          borderRadius: 12,
          padding: '12px 18px',
          margin: '0 0 22px 0',
          fontWeight: 500,
          lineHeight: 1.5,
          boxShadow: '0 1px 4px rgba(29,102,93,0.06)'
        }}>
          <b>Access our map of over 18,000 golf courses<br /><br />
          Instantly filter by ranking, public or private, architect, and more<br /><br />
          See the courses we recommend in your area or wherever you plan to travel to next</b>
        </div>
        <button
          className="btn btn-primary"
          style={{ width: '100%', borderRadius: 999, padding: '14px 0', fontSize: 18, marginBottom: 18 }}
          onClick={() => { window.location.href = '/signup'; }}
        >
          Create a free account
        </button>
        <div style={{ fontSize: 16, color: '#222', marginBottom: 0 }}>
          Already have an account?{' '}
          <a href="/login" style={{ color: '#1D665D', textDecoration: 'underline', fontWeight: 600 }}>Log in</a>
        </div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 18 }}>
          By continuing to use Golf Near Me, you agree to our{' '}
          <a href="/terms" style={{ color: '#888', textDecoration: 'underline' }}>Terms of Service</a> and{' '}
          <a href="/privacy" style={{ color: '#888', textDecoration: 'underline' }}>Privacy Policy</a>.
        </div>
      </div>
    </div>
  );
} 